import { render, staticRenderFns } from "./ViewCounter.vue?vue&type=template&id=4360d385&scoped=true&"
import script from "./ViewCounter.vue?vue&type=script&lang=js&"
export * from "./ViewCounter.vue?vue&type=script&lang=js&"
import style0 from "./ViewCounter.vue?vue&type=style&index=0&id=4360d385&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4360d385",
  null
  
)

export default component.exports